// Utility function to normalize percentage input to a float
export const normalizePercentageInput = (input: any) => {
    if (!input) return null;
    // Remove any percentage signs and replace commas with dots
    let normalizedInput = input.replace('%', '').replace(',', '.');
    // Convert to a float
    let value = parseFloat(normalizedInput);
    // If the input was in percentage (greater than 1), convert it to a fraction
    if (value > 1) value = value / 100;
    return value;
  };